// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  BQA_REFRESH_CHART: 60000,
  API: "https://backend.221b.engpro.totvs.com.br/cli/",
  url_v1: "https://api-v1.esp.pre.engpro.totvs.com.br/api/v1",
  url_v1_v2: "https://api-v1.esp.pre.engpro.totvs.com.br/api/v2",
  url_v2: "https://api-v2.esp.pre.engpro.totvs.com.br/api/v2",
  API_CHAT: "https://chat.esp.pre.engpro.totvs.com.br/chat",
  QUERY_ANALYZER_V2_API: "https://pre.api.queryanalyzer.engpro.totvs.io",
  SMART_REVIEW_API: "https://smart-review.pre.engpro.totvs.io",
  SONAR_EXTRACTOR_API: "https://sonar-extractor.pre.engpro.totvs.io/",
  DATASTUDIO_URL: "https://datastudio.google.com/embed/reporting/1db8e0c6-3fac-443c-aa30-b4fdb9d557e4/page/f0e0F",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
